function SvgMore({ className }) {
    return (
      <svg
        className={`${className}`}
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10 7.625C11.0352 7.625 11.875 8.46484 11.875 9.5C11.875 10.5352 11.0352 11.375 10 11.375C8.96484 11.375 8.125 10.5352 8.125 9.5C8.125 8.46484 8.96484 7.625 10 7.625ZM8.125 2.9375C8.125 3.97266 8.96484 4.8125 10 4.8125C11.0352 4.8125 11.875 3.97266 11.875 2.9375C11.875 1.90234 11.0352 1.0625 10 1.0625C8.96484 1.0625 8.125 1.90234 8.125 2.9375ZM8.125 16.0625C8.125 17.0977 8.96484 17.9375 10 17.9375C11.0352 17.9375 11.875 17.0977 11.875 16.0625C11.875 15.0273 11.0352 14.1875 10 14.1875C8.96484 14.1875 8.125 15.0273 8.125 16.0625Z"
          fill="currentColor"
        />
      </svg>
    );
  }
  
  export default SvgMore;
  